module.exports = __webpack_public_path__ + "static/media/pending.c07b0fd1.png";